export default function getGridWidthClass(gridCol) {
  const widthClasses = {
    1: 'w-full',
    2: 'w-full',
    3: 'w-full',
    4: 'w-full',
    5: 'w-full',
    6: 'w-full',
    7: 'w-full',
    8: 'w-full',
    9: 'w-full',
    10: 'w-full',
    11: 'w-full',
    12: 'w-full',
    13: 'w-full',
    14: 'w-full',
    15: 'w-full',
    16: 'w-full',
    17: 'w-full',
    18: 'w-full',
    19: 'w-full',
    20: 'w-full',
    21: 'w-full',
    22: 'w-full',
    23: 'w-full',
    24: 'w-full',
  };

  return widthClasses[gridCol];
}
